import { render, staticRenderFns } from "./RdmUnsavedChangesModal.vue?vue&type=template&id=3bd55a20&scoped=true&"
import script from "./RdmUnsavedChangesModal.vue?vue&type=script&lang=ts&"
export * from "./RdmUnsavedChangesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd55a20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
